import { ProductDto, ProductsApi } from '@eurogast/hub-client-typescript';
import { ApiService } from '@/services/ApiService';
import { ConfigService } from '@/services/ConfigService';

export default class ProductApiWrapper {
  private static instance = new ProductApiWrapper();

  public static singleton(): ProductApiWrapper {
    return this.instance;
  }

  private constructor() {
  }

  private lateinitApi: ProductsApi;

  private get api(): ProductsApi {
    if (!this.lateinitApi) {
      this.lateinitApi = ApiService.wrap(ProductsApi);
    }

    return this.lateinitApi;
  }

  public async getProductBySkuBatch(
    skus: string[],
    showInactive?: boolean,
    cartType?: string
  ): Promise<ProductDto[]> {
    const productDtos = await this.api.getProductBySkuBatch(
      ConfigService.getTenant(),
      skus,
      ConfigService.currentCustomerIdOrNull,
      showInactive,
      cartType
    );

    return skus
      .map((sku) => productDtos.find((p) => p.sku === sku))
      .filter((productDto) => productDto != null);
  }

  public async getCartPromotedProducts(): Promise<ProductDto[]> {
    return this.api.getCartPromotedProducts(
      ConfigService.getTenant(),
      ConfigService.currentCustomerId
    );
  }
}
